export const title = 'Downloads (Gráfico)';

Quantidade de novas instalações do app ao longo do tempo.